var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "field-creator" },
    [
      _c(
        "a-form",
        {
          on: {
            submit: function ($event) {
              $event.preventDefault()
              _vm.mode === "create" ? _vm.createField() : _vm.updateField()
            },
          },
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", gap: "16px" } },
            [
              _c(
                "a-form-item",
                {
                  staticStyle: { flex: "0 0 auto" },
                  attrs: { label: _vm.$t("İkon") },
                },
                [
                  _c("MaterialIconPicker", {
                    model: {
                      value: _vm.cloneField.icon,
                      callback: function ($$v) {
                        _vm.$set(_vm.cloneField, "icon", $$v)
                      },
                      expression: "cloneField.icon",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "a-form-item",
                {
                  staticStyle: { flex: "1" },
                  attrs: { label: _vm.$t("message.name"), required: true },
                },
                [
                  _c("a-input", {
                    model: {
                      value: _vm.cloneField.name,
                      callback: function ($$v) {
                        _vm.$set(_vm.cloneField, "name", $$v)
                      },
                      expression: "cloneField.name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.fieldType"), required: true } },
            [
              _c(
                "a-select",
                {
                  attrs: { disabled: _vm.mode === "update" },
                  on: { change: _vm.onFieldTypeChange },
                  model: {
                    value: _vm.cloneField.fieldType,
                    callback: function ($$v) {
                      _vm.$set(_vm.cloneField, "fieldType", $$v)
                    },
                    expression: "cloneField.fieldType",
                  },
                },
                _vm._l(_vm.fieldTypes, function (type) {
                  return _c(
                    "a-select-option",
                    { key: type.value, attrs: { value: type.value } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(type.label) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.alignment"), required: true } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.cloneField.alignment,
                    callback: function ($$v) {
                      _vm.$set(_vm.cloneField, "alignment", $$v)
                    },
                    expression: "cloneField.alignment",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "left" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.left"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "center" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.center"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "right" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.right"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          !_vm.cloneField.fieldType.startsWith("record_") &&
          !["formula", "lookup", "auto-increment"].includes(
            _vm.cloneField.fieldType
          )
            ? _c(
                "a-form-item",
                { attrs: { label: _vm.$t("Varsayılan Değer") } },
                [
                  [
                    "text",
                    "email",
                    "url",
                    "color",
                    "phone",
                    "long-text",
                  ].includes(_vm.cloneField.fieldType)
                    ? _c("a-input", {
                        attrs: {
                          placeholder: _vm.$t("Varsayılan bir değer girin"),
                        },
                        model: {
                          value: _vm.cloneField.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.cloneField, "defaultValue", $$v)
                          },
                          expression: "cloneField.defaultValue",
                        },
                      })
                    : ["number", "currency"].includes(_vm.cloneField.fieldType)
                    ? _c("a-input-number", {
                        staticStyle: { width: "100%" },
                        model: {
                          value: _vm.cloneField.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.cloneField, "defaultValue", $$v)
                          },
                          expression: "cloneField.defaultValue",
                        },
                      })
                    : _vm.cloneField.fieldType === "datetime"
                    ? _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            gap: "10px",
                            "align-items": "center",
                          },
                        },
                        [
                          !_vm.useCurrentDateTimeAsDefault
                            ? _c("a-date-picker", {
                                staticStyle: { width: "100%" },
                                attrs: {
                                  showTime:
                                    _vm.cloneField.options.datetime.includeTime,
                                  format: _vm.cloneField.options.datetime
                                    .includeTime
                                    ? _vm.cloneField.options.datetime.format +
                                      " " +
                                      _vm.cloneField.options.datetime.timeFormat
                                    : _vm.cloneField.options.datetime.format,
                                },
                                model: {
                                  value: _vm.cloneField.defaultValue,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.cloneField,
                                      "defaultValue",
                                      $$v
                                    )
                                  },
                                  expression: "cloneField.defaultValue",
                                },
                              })
                            : _c("span", [
                                _vm._v(_vm._s(_vm.$t("Şu anki tarih/saat"))),
                              ]),
                          _vm._v(" "),
                          _c(
                            "a-checkbox",
                            {
                              model: {
                                value: _vm.useCurrentDateTimeAsDefault,
                                callback: function ($$v) {
                                  _vm.useCurrentDateTimeAsDefault = $$v
                                },
                                expression: "useCurrentDateTimeAsDefault",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("Şu anki tarih/saati kullan"))
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm.cloneField.fieldType === "checkbox"
                    ? _c("a-switch", {
                        model: {
                          value: _vm.cloneField.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.cloneField, "defaultValue", $$v)
                          },
                          expression: "cloneField.defaultValue",
                        },
                      })
                    : _vm.cloneField.fieldType === "dropdown"
                    ? _c(
                        "div",
                        [
                          _vm.cloneField.options.dropdown.mode === "static"
                            ? _c(
                                "a-select",
                                {
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    mode: _vm.cloneField.options.dropdown
                                      .multiple
                                      ? "multiple"
                                      : undefined,
                                  },
                                  model: {
                                    value: _vm.cloneField.defaultValue,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.cloneField,
                                        "defaultValue",
                                        $$v
                                      )
                                    },
                                    expression: "cloneField.defaultValue",
                                  },
                                },
                                _vm._l(
                                  _vm.cloneField.options.dropdown.options,
                                  function (option, index) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: index,
                                        attrs: { value: option.value },
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(option.value) +
                                            "\n                    "
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              )
                            : _c("a-input", {
                                attrs: {
                                  disabled: "",
                                  placeholder: _vm.$t(
                                    "Dinamik dropdown için varsayılan değer belirlenemez"
                                  ),
                                },
                              }),
                        ],
                        1
                      )
                    : _vm.cloneField.fieldType === "json"
                    ? _c("a-textarea", {
                        attrs: {
                          rows: "4",
                          placeholder: _vm.$t("Geçerli bir JSON değeri girin"),
                        },
                        model: {
                          value: _vm.cloneField.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.cloneField, "defaultValue", $$v)
                          },
                          expression: "cloneField.defaultValue",
                        },
                      })
                    : [
                        "linked-record",
                        "contact",
                        "ticket",
                        "task",
                        "event",
                        "conversation",
                        "user",
                      ].includes(_vm.cloneField.fieldType)
                    ? _c("a-input", {
                        attrs: {
                          disabled: "",
                          placeholder: _vm.$t(
                            "Bu alan tipine varsayılan değer belirlenemez"
                          ),
                        },
                      })
                    : ["file", "image", "video", "audio"].includes(
                        _vm.cloneField.fieldType
                      )
                    ? _c("a-input", {
                        attrs: {
                          disabled: "",
                          placeholder: _vm.$t(
                            "Dosya alanları için varsayılan değer ayarlanamaz"
                          ),
                        },
                      })
                    : _vm.cloneField.fieldType === "ai"
                    ? _c("a-input", {
                        attrs: {
                          placeholder: _vm.$t(
                            "AI tarafından üretilecek ilk değer (opsiyonel)"
                          ),
                        },
                        model: {
                          value: _vm.cloneField.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.cloneField, "defaultValue", $$v)
                          },
                          expression: "cloneField.defaultValue",
                        },
                      })
                    : _c("a-input", {
                        model: {
                          value: _vm.cloneField.defaultValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.cloneField, "defaultValue", $$v)
                          },
                          expression: "cloneField.defaultValue",
                        },
                      }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.fieldType"), required: true } },
            [
              _c(
                "a-select",
                {
                  attrs: { disabled: _vm.mode === "update" },
                  on: { change: _vm.onFieldTypeChange },
                  model: {
                    value: _vm.cloneField.fieldType,
                    callback: function ($$v) {
                      _vm.$set(_vm.cloneField, "fieldType", $$v)
                    },
                    expression: "cloneField.fieldType",
                  },
                },
                _vm._l(_vm.fieldTypes, function (type) {
                  return _c(
                    "a-select-option",
                    { key: type.value, attrs: { value: type.value } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(type.label) +
                          "\n                "
                      ),
                    ]
                  )
                }),
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-form-item",
            { attrs: { label: _vm.$t("tables.alignment"), required: true } },
            [
              _c(
                "a-select",
                {
                  model: {
                    value: _vm.cloneField.alignment,
                    callback: function ($$v) {
                      _vm.$set(_vm.cloneField, "alignment", $$v)
                    },
                    expression: "cloneField.alignment",
                  },
                },
                [
                  _c("a-select-option", { attrs: { value: "left" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.left"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "center" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.center"))),
                  ]),
                  _vm._v(" "),
                  _c("a-select-option", { attrs: { value: "right" } }, [
                    _vm._v(_vm._s(_vm.$t("tables.right"))),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _vm.cloneField.fieldType === "datetime"
            ? [
                _c("a-divider", [
                  _vm._v(_vm._s(_vm.$t("tables.datetimeOptions"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.timezone") } },
                  [
                    _c("a-auto-complete", {
                      attrs: {
                        dataSource: _vm.timezones,
                        placeholder: _vm.$t("tables.timezone"),
                        filterOption: _vm.filterOption,
                      },
                      model: {
                        value: _vm.cloneField.options.datetime.timezone,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.datetime,
                            "timezone",
                            $$v
                          )
                        },
                        expression: "cloneField.options.datetime.timezone",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Format" } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.cloneField.options.datetime.format,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.datetime,
                              "format",
                              $$v
                            )
                          },
                          expression: "cloneField.options.datetime.format",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { attrs: { value: "MM/DD/YYYY" } },
                          [_vm._v("MM/DD/YYYY (12/31/2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD/MM/YYYY" } },
                          [_vm._v("DD/MM/YYYY (31/12/2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "YYYY-MM-DD" } },
                          [_vm._v("YYYY-MM-DD (2023-12-31)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "MM-DD-YYYY" } },
                          [_vm._v("MM-DD-YYYY (12-31-2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD-MM-YYYY" } },
                          [_vm._v("DD-MM-YYYY (31-12-2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "YYYY/MM/DD" } },
                          [_vm._v("YYYY/MM/DD (2023/12/31)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "MMM DD, YYYY" } },
                          [_vm._v("MMM DD, YYYY (Dec 31, 2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD MMM, YYYY" } },
                          [_vm._v("DD MMM, YYYY (31 Dec, 2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "MMMM DD, YYYY" } },
                          [_vm._v("MMMM DD, YYYY (December 31, 2023)")]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "DD MMMM, YYYY" } },
                          [_vm._v("DD MMMM, YYYY (31 December, 2023)")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.includeTime") } },
                  [
                    _c("a-switch", {
                      model: {
                        value: _vm.cloneField.options.datetime.includeTime,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.datetime,
                            "includeTime",
                            $$v
                          )
                        },
                        expression: "cloneField.options.datetime.includeTime",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cloneField.options.datetime.includeTime
                  ? _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("tables.timeFormat") } },
                      [
                        _c(
                          "a-select",
                          {
                            model: {
                              value: _vm.cloneField.options.datetime.timeFormat,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cloneField.options.datetime,
                                  "timeFormat",
                                  $$v
                                )
                              },
                              expression:
                                "cloneField.options.datetime.timeFormat",
                            },
                          },
                          [
                            _c(
                              "a-select-option",
                              { attrs: { value: "HH:mm" } },
                              [_vm._v("HH:mm (23:59)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "hh:mm A" } },
                              [_vm._v("hh:mm A (11:59 PM)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "HH:mm:ss" } },
                              [_vm._v("HH:mm:ss (23:59:59)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "hh:mm:ss A" } },
                              [_vm._v("hh:mm:ss A (11:59:59 PM)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "HH:mm:ss.SSS" } },
                              [_vm._v("HH:mm:ss.SSS (23:59:59.999)")]
                            ),
                            _vm._v(" "),
                            _c(
                              "a-select-option",
                              { attrs: { value: "hh:mm:ss.SSS A" } },
                              [_vm._v("hh:mm:ss.SSS A (11:59:59.999 PM)")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label: _vm.$t(
                        "Varsayılan Zaman Olarak Şu An Aktif Edilsin"
                      ),
                    },
                  },
                  [
                    _c("a-switch", {
                      model: {
                        value: _vm.cloneField.options.datetime.defaultNow,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.datetime,
                            "defaultNow",
                            $$v
                          )
                        },
                        expression: "cloneField.options.datetime.defaultNow",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.cloneField.fieldType === "number"
            ? [
                _c("a-divider", [
                  _vm._v(_vm._s(_vm.$t("tables.numberOptions"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.decimalFormat") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.cloneField.options.number.decimalFormat,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.number,
                              "decimalFormat",
                              $$v
                            )
                          },
                          expression: "cloneField.options.number.decimalFormat",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "0" } }, [
                          _vm._v("0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0" } }, [
                          _vm._v("0.0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00" } }, [
                          _vm._v("0.00"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.000" } }, [
                          _vm._v("0.000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0000" } }, [
                          _vm._v("0.0000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00000" } }, [
                          _vm._v("0.00000"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "0.000000" } },
                          [_vm._v("0.000000")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.cloneField.fieldType === "currency"
            ? [
                _c("a-divider", [
                  _vm._v(_vm._s(_vm.$t("tables.currencyOptions"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.currencySymbol") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.cloneField.options.currency.symbol,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.currency,
                              "symbol",
                              $$v
                            )
                          },
                          expression: "cloneField.options.currency.symbol",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "$" } }, [
                          _vm._v("$ (USD)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "€" } }, [
                          _vm._v("€ (EUR)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "£" } }, [
                          _vm._v("£ (GBP)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "¥" } }, [
                          _vm._v("¥ (JPY)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₽" } }, [
                          _vm._v("₽ (RUB)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₹" } }, [
                          _vm._v("₹ (INR)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₺" } }, [
                          _vm._v("₺ (TRY)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "₩" } }, [
                          _vm._v("₩ (KRW)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "R$" } }, [
                          _vm._v("R$ (BRL)"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "¥" } }, [
                          _vm._v("¥ (CNY)"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.decimalFormat") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.cloneField.options.currency.decimalFormat,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.currency,
                              "decimalFormat",
                              $$v
                            )
                          },
                          expression:
                            "cloneField.options.currency.decimalFormat",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "0" } }, [
                          _vm._v("0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0" } }, [
                          _vm._v("0.0"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00" } }, [
                          _vm._v("0.00"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.000" } }, [
                          _vm._v("0.000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.0000" } }, [
                          _vm._v("0.0000"),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "0.00000" } }, [
                          _vm._v("0.00000"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "0.000000" } },
                          [_vm._v("0.000000")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm.cloneField.fieldType === "dropdown"
            ? [
                _c("a-divider", [
                  _vm._v(_vm._s(_vm.$t("tables.dropdownOptions"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.mode") } },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.cloneField.options.dropdown.mode,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.dropdown,
                              "mode",
                              $$v
                            )
                          },
                          expression: "cloneField.options.dropdown.mode",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "static" } }, [
                          _vm._v(_vm._s(_vm.$t("tables.statics"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "dynamic" } }, [
                          _vm._v("Dynamic"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.multipleSelection") } },
                  [
                    _c("a-switch", {
                      attrs: { disabled: _vm.mode === "update" },
                      model: {
                        value: _vm.cloneField.options.dropdown.multiple,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.dropdown,
                            "multiple",
                            $$v
                          )
                        },
                        expression: "cloneField.options.dropdown.multiple",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cloneField.options.dropdown.mode === "static"
                  ? _c(
                      "div",
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: _vm.$t("message.options") } },
                          [
                            _vm._l(
                              _vm.cloneField.options.dropdown.options,
                              function (option, index) {
                                return _c(
                                  "div",
                                  { key: index, staticClass: "option-item" },
                                  [
                                    _c("a-input", {
                                      staticStyle: { width: "60%" },
                                      attrs: {
                                        placeholder: _vm.$t("message.value"),
                                      },
                                      model: {
                                        value: option.value,
                                        callback: function ($$v) {
                                          _vm.$set(option, "value", $$v)
                                        },
                                        expression: "option.value",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "a-select",
                                      {
                                        staticStyle: {
                                          width: "30%",
                                          "margin-left": "10px",
                                        },
                                        attrs: {
                                          placeholder: _vm.$t("tables.color"),
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "suffixIcon",
                                              fn: function () {
                                                return [
                                                  _c("div", {
                                                    staticClass: "color-box",
                                                    style: {
                                                      backgroundColor:
                                                        _vm.selectedColor(
                                                          option.color
                                                        ),
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: option.color,
                                          callback: function ($$v) {
                                            _vm.$set(option, "color", $$v)
                                          },
                                          expression: "option.color",
                                        },
                                      },
                                      [
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.colors,
                                          function (color, colorIndex) {
                                            return _c(
                                              "a-select-option",
                                              {
                                                key: colorIndex,
                                                attrs: { value: color.value },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "color-option",
                                                  },
                                                  [
                                                    _c("div", {
                                                      staticClass: "color-box",
                                                      style: {
                                                        backgroundColor:
                                                          color.value,
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(color.label)
                                                      ),
                                                    ]),
                                                  ]
                                                ),
                                              ]
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c("a-button", {
                                      staticStyle: { "margin-left": "10px" },
                                      attrs: { type: "danger", icon: "delete" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeOption(index)
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            _vm._v(" "),
                            _c(
                              "a-button",
                              {
                                attrs: { type: "dashed", icon: "plus" },
                                on: { click: _vm.addOption },
                              },
                              [_vm._v(_vm._s(_vm.$t("tables.addOption")))]
                            ),
                          ],
                          2
                        ),
                      ],
                      1
                    )
                  : _vm.cloneField.options.dropdown.mode === "dynamic"
                  ? _c(
                      "div",
                      [
                        _c(
                          "a-form-item",
                          { attrs: { label: "Tablo ve Kolon Seçimi" } },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex", gap: "10px" } },
                              [
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { flex: "1" },
                                    attrs: { placeholder: "Tablo Seç" },
                                    on: { change: _vm.onTableChange },
                                    model: {
                                      value:
                                        _vm.cloneField.options.dropdown
                                          .remoteTable,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.cloneField.options.dropdown,
                                          "remoteTable",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cloneField.options.dropdown.remoteTable",
                                    },
                                  },
                                  _vm._l(_vm.tables, function (table) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: table._id,
                                        attrs: { value: table._id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(table.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "a-select",
                                  {
                                    staticStyle: { flex: "1" },
                                    attrs: {
                                      disabled:
                                        !_vm.cloneField.options.dropdown
                                          .remoteTable,
                                      placeholder: "Kolon Seç",
                                    },
                                    model: {
                                      value:
                                        _vm.cloneField.options.dropdown
                                          .remoteTableField,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.cloneField.options.dropdown,
                                          "remoteTableField",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "cloneField.options.dropdown.remoteTableField",
                                    },
                                  },
                                  _vm._l(_vm.getStringFields, function (field) {
                                    return _c(
                                      "a-select-option",
                                      {
                                        key: field._id,
                                        attrs: { value: field._id },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                " +
                                            _vm._s(field.name) +
                                            "\n                            "
                                        ),
                                      ]
                                    )
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm.cloneField.fieldType === "automation-button"
            ? [
                _c("a-divider", [
                  _vm._v(_vm._s(_vm.$t("tables.automationButtonOptions"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("automation.automationName") } },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.cloneField.options.button.automationName,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.button,
                            "automationName",
                            $$v
                          )
                        },
                        expression: "cloneField.options.button.automationName",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label: _vm.$t("tables.defaultLabel"),
                      required: true,
                    },
                  },
                  [
                    _c("a-input", {
                      model: {
                        value: _vm.cloneField.options.button.defaultLabel,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.button,
                            "defaultLabel",
                            $$v
                          )
                        },
                        expression: "cloneField.options.button.defaultLabel",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("tables.disableWhenClicked") } },
                  [
                    _c("a-switch", {
                      model: {
                        value: _vm.cloneField.options.button.disableWhenClicked,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.button,
                            "disableWhenClicked",
                            $$v
                          )
                        },
                        expression:
                          "cloneField.options.button.disableWhenClicked",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.cloneField.fieldType === "linked-record"
            ? [
                _c("a-divider", [_vm._v("Linked Record Options")]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Select Table" } },
                  [
                    _c(
                      "a-select",
                      {
                        attrs: { placeholder: "Select Table" },
                        on: { change: _vm.onLinkedTableChange },
                        model: {
                          value: _vm.cloneField.options.linkedRecord.table,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.linkedRecord,
                              "table",
                              $$v
                            )
                          },
                          expression: "cloneField.options.linkedRecord.table",
                        },
                      },
                      _vm._l(_vm.tables, function (table) {
                        return _c(
                          "a-select-option",
                          { key: table._id, attrs: { value: table._id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(table.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cloneField.options.linkedRecord.table
                  ? _c(
                      "a-form-item",
                      { attrs: { label: "Label Field" } },
                      [
                        _c(
                          "a-select",
                          {
                            attrs: { placeholder: "Select Label Field" },
                            model: {
                              value:
                                _vm.cloneField.options.linkedRecord.labelField,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cloneField.options.linkedRecord,
                                  "labelField",
                                  $$v
                                )
                              },
                              expression:
                                "cloneField.options.linkedRecord.labelField",
                            },
                          },
                          _vm._l(_vm.getLinkedTableFields, function (field) {
                            return _c(
                              "a-select-option",
                              { key: field._id, attrs: { value: field._id } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(field.name) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm.cloneField.fieldType === "ai"
            ? [
                _c("a-divider", [
                  _vm._v(_vm._s(_vm.$t("Yapay Zeka Ayarları"))),
                ]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Prompt", required: true } },
                  [
                    _c("a-textarea", {
                      attrs: {
                        rows: 4,
                        placeholder: _vm.$t(
                          "Promptu buraya giriniz. Veri analizi yapmasını istebilirsiniz. Kayıtı kategorize etmek için kullanabilirsiniz. Duygu analizi veya çeviri yapmasını isteyebilirsiniz."
                        ),
                      },
                      model: {
                        value: _vm.cloneField.options.ai.prompt,
                        callback: function ($$v) {
                          _vm.$set(_vm.cloneField.options.ai, "prompt", $$v)
                        },
                        expression: "cloneField.options.ai.prompt",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label: _vm.$t("Ne zaman çalıştırılsın"),
                      required: true,
                    },
                  },
                  [
                    _c(
                      "a-select",
                      {
                        model: {
                          value: _vm.cloneField.options.ai.runAt,
                          callback: function ($$v) {
                            _vm.$set(_vm.cloneField.options.ai, "runAt", $$v)
                          },
                          expression: "cloneField.options.ai.runAt",
                        },
                      },
                      [
                        _c(
                          "a-select-option",
                          { attrs: { value: "only-on-create" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("Kayıt Oluşturulduğunda Çalışır")
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "a-select-option",
                          { attrs: { value: "on-every-change" } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(
                                  _vm.$t("Her Kayıt Değiştiğinde Çalışır")
                                ) +
                                "\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "manual" } }, [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("Button ile tetiklediğinde")) +
                              "\n                    "
                          ),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("İşlenecek Alanlar") } },
                  [
                    _c(
                      "a-select",
                      {
                        on: { change: _vm.onFieldsProcessingChange },
                        model: {
                          value: _vm.cloneField.options.ai.whichFieldsToProcess,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.ai,
                              "whichFieldsToProcess",
                              $$v
                            )
                          },
                          expression:
                            "cloneField.options.ai.whichFieldsToProcess",
                        },
                      },
                      [
                        _c("a-select-option", { attrs: { value: "all" } }, [
                          _vm._v(_vm._s(_vm.$t("Tüm Alanlar"))),
                        ]),
                        _vm._v(" "),
                        _c("a-select-option", { attrs: { value: "custom" } }, [
                          _vm._v(_vm._s(_vm.$t("Özel Alanlar"))),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cloneField.options.ai.whichFieldsToProcess === "custom"
                  ? _c(
                      "a-form-item",
                      { attrs: { label: _vm.$t("Alan Seçimi") } },
                      [
                        _c(
                          "a-select",
                          {
                            attrs: {
                              mode: "multiple",
                              placeholder: _vm.$t("İşlenecek alanları seçin"),
                            },
                            model: {
                              value: _vm.cloneField.options.ai.fieldsToProcess,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cloneField.options.ai,
                                  "fieldsToProcess",
                                  $$v
                                )
                              },
                              expression:
                                "cloneField.options.ai.fieldsToProcess",
                            },
                          },
                          _vm._l(_vm.tableFields, function (field) {
                            return _c(
                              "a-select-option",
                              { key: field._id, attrs: { value: field._id } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(field.name) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm.cloneField.fieldType === "formula"
            ? [
                _c("a-divider", [_vm._v(_vm._s(_vm.$t("Formül Ayarları")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: "Formül İfadesi", required: true } },
                  [
                    _c("FormulaFieldEditor", {
                      attrs: {
                        tableId: _vm.tableId,
                        allFields: _vm.tableFields,
                      },
                      model: {
                        value: _vm.cloneField.options.formula.expression,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.formula,
                            "expression",
                            $$v
                          )
                        },
                        expression: "cloneField.options.formula.expression",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm.cloneField.fieldType === "lookup"
            ? [
                _c("a-divider", [_vm._v(_vm._s(_vm.$t("Lookup Ayarları")))]),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: { label: "Bağlantılı Kayıt Alanı", required: true },
                  },
                  [
                    _c(
                      "a-select",
                      {
                        attrs: {
                          placeholder: "Bağlantılı Kayıt Alanını Seçin",
                        },
                        on: { change: _vm.onLinkedRecordFieldChange },
                        model: {
                          value:
                            _vm.cloneField.options.lookup.linkedRecordField,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.cloneField.options.lookup,
                              "linkedRecordField",
                              $$v
                            )
                          },
                          expression:
                            "cloneField.options.lookup.linkedRecordField",
                        },
                      },
                      _vm._l(_vm.getLinkedRecordFields, function (field) {
                        return _c(
                          "a-select-option",
                          { key: field._id, attrs: { value: field._id } },
                          [
                            _vm._v(
                              "\n                        " +
                                _vm._s(field.name) +
                                "\n                    "
                            ),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.cloneField.options.lookup.linkedRecordField
                  ? _c(
                      "a-form-item",
                      { attrs: { label: "Hedef Alan", required: true } },
                      [
                        _c(
                          "a-select",
                          {
                            attrs: { placeholder: "Hedef Alanı Seçin" },
                            model: {
                              value: _vm.cloneField.options.lookup.targetField,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cloneField.options.lookup,
                                  "targetField",
                                  $$v
                                )
                              },
                              expression:
                                "cloneField.options.lookup.targetField",
                            },
                          },
                          _vm._l(_vm.getTargetFields, function (field) {
                            return _c(
                              "a-select-option",
                              { key: field._id, attrs: { value: field._id } },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(field.name) +
                                    "\n                    "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]
            : _vm.cloneField.fieldType === "auto-increment"
            ? [
                _c("a-divider", [
                  _vm._v(_vm._s(_vm.$t("Auto Increment Ayarları"))),
                ]),
                _vm._v(" "),
                _vm.mode === "create"
                  ? [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("Format"), required: true } },
                        [
                          _c(
                            "a-select",
                            {
                              on: { change: _vm.onFieldTypeChange },
                              model: {
                                value:
                                  _vm.cloneField.options.autoIncrement.format,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.cloneField.options.autoIncrement,
                                    "format",
                                    $$v
                                  )
                                },
                                expression:
                                  "cloneField.options.autoIncrement.format",
                              },
                            },
                            [
                              _c(
                                "a-select-option",
                                { attrs: { value: "number" } },
                                [_vm._v(_vm._s(_vm.$t("Sayı")))]
                              ),
                              _vm._v(" "),
                              _c(
                                "a-select-option",
                                { attrs: { value: "string" } },
                                [_vm._v(_vm._s(_vm.$t("Metin")))]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.cloneField.options.autoIncrement.format === "string"
                  ? [
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("Ön Ek"), required: false } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "Örn: INV-" },
                            model: {
                              value:
                                _vm.cloneField.options.autoIncrement.prefix,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cloneField.options.autoIncrement,
                                  "prefix",
                                  $$v
                                )
                              },
                              expression:
                                "cloneField.options.autoIncrement.prefix",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "a-form-item",
                        { attrs: { label: _vm.$t("Son Ek"), required: false } },
                        [
                          _c("a-input", {
                            attrs: { placeholder: "Örn: -2024" },
                            model: {
                              value:
                                _vm.cloneField.options.autoIncrement.suffix,
                              callback: function ($$v) {
                                _vm.$set(
                                  _vm.cloneField.options.autoIncrement,
                                  "suffix",
                                  $$v
                                )
                              },
                              expression:
                                "cloneField.options.autoIncrement.suffix",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  {
                    attrs: {
                      label: _vm.$t("Başlangıç Değeri"),
                      required: true,
                    },
                  },
                  [
                    _c("a-input-number", {
                      attrs: {
                        min: 1,
                        step: 1,
                        disabled: _vm.mode === "update",
                      },
                      model: {
                        value: _vm.cloneField.options.autoIncrement.startValue,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.autoIncrement,
                            "startValue",
                            $$v
                          )
                        },
                        expression:
                          "cloneField.options.autoIncrement.startValue",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "a-form-item",
                  { attrs: { label: _vm.$t("Artış Miktarı"), required: true } },
                  [
                    _c("a-input-number", {
                      attrs: { min: 1, step: 1 },
                      model: {
                        value: _vm.cloneField.options.autoIncrement.increment,
                        callback: function ($$v) {
                          _vm.$set(
                            _vm.cloneField.options.autoIncrement,
                            "increment",
                            $$v
                          )
                        },
                        expression:
                          "cloneField.options.autoIncrement.increment",
                      },
                    }),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a-form-item",
            [
              _c(
                "a-button",
                {
                  attrs: {
                    type: "primary",
                    "html-type": "submit",
                    loading: _vm.loading,
                    disabled: _vm.loading,
                  },
                },
                [
                  _vm._v(
                    "\n                " +
                      _vm._s(
                        _vm.mode === "create"
                          ? _vm.$t("tables.create")
                          : _vm.$t("message.update")
                      ) +
                      "\n            "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "a-button",
                { attrs: { disabled: _vm.loading }, on: { click: _vm.cancel } },
                [_vm._v(_vm._s(_vm.$t("wp.cancel")))]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }